import type { DescMessage, MessageInitShape } from '@bufbuild/protobuf';
import { create, toBinary } from '@bufbuild/protobuf';

import { Envelope } from './envelope';

export class EncodedBodyEnvelope extends Envelope {
  public static toBinary<D extends DescMessage>(
    flags: number,
    message: D,
    input: MessageInitShape<D>,
  ): EncodedBodyEnvelope {
    return new EncodedBodyEnvelope(
      flags,
      toBinary(message, create(message, input)),
    );
  }

  private constructor(
    flags: number,
    public override readonly bytes: Uint8Array,
  ) {
    super(flags, bytes);
  }
}
